import { useMantineTheme } from '@mantine/core';
import type { EdgeProps } from '@xyflow/react';
import { BaseEdge } from '@xyflow/react';
import { memo, useMemo } from 'react';
import { getLineageFlowBezierPath } from '../../utils/getLineageFlowBezierPath';
import type { LineageFlowEdge } from './EntityEdge.types';
import { EntityEdgeWithJob } from './EntityEdgeWithJob';

export const EntityEdge = memo(
	({
		id,
		sourceX,
		sourceY,
		targetX,
		targetY,
		sourcePosition,
		targetPosition,
		markerEnd,
		data,
	}: EdgeProps<LineageFlowEdge>) => {
		const theme = useMantineTheme();

		const [edgePath, labelX, labelY] = getLineageFlowBezierPath({
			sourceX,
			sourceY,
			sourcePosition,
			targetX,
			targetY,
			targetPosition,
		});

		const style = useMemo(
			() => ({
				stroke: theme.other.getColor('border/primary/default'),
				strokeWidth: 1,
			}),
			[theme]
		);

		if (data?.job_metadata) {
			return (
				<EntityEdgeWithJob
					id={id}
					path={edgePath}
					labelX={labelX}
					labelY={labelY}
					markerEnd={markerEnd}
					style={style}
					isHovered={data.hovered}
					metadata={data.job_metadata}
				/>
			);
		}

		return (
			<BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
		);
	}
);
